import * as echarts from "echarts";
import type { ChartConfig } from "@bi-studio/shared/lib";
import type { ChartData, ChartSize } from "./types";
import {
   getChartInstance,
   setupResize,
   clearContainer,
   resolveColors,
} from "./utils";

export const renderScatterChart = (
   container: HTMLElement | null,
   data: ChartData,
   config: ChartConfig,
   _size?: ChartSize,
   theme: 'light' | 'dark' = 'light'
): HTMLElement | null => {
   if (!container || typeof window === "undefined") return null;

   clearContainer(container);

   // Set container size
   container.style.width = "100%";
   container.style.height = "100%";

   const chartInstance = getChartInstance(container, theme);
   const colors = resolveColors(config, theme);

   // Prepare data for ECharts - scatter usually expects [x, y]
   const seriesData = data.map((row) => [
      Number(row[config.xField ?? ""]) || 0,
      Number(row[config.yField ?? ""]) || 0,
   ]);

   const option: echarts.EChartsOption = {
      backgroundColor: 'transparent',
      tooltip: {
         trigger: "item",
         formatter: (params: any) => {
             return `${config.xField || 'X'}: ${params.value[0]}<br/>${config.yField || 'Y'}: ${params.value[1]}`;
         }
      },
      grid: {
         left: "10%",
         right: "10%",
         bottom: "15%",
         top: "10%",
         containLabel: true,
      },
      xAxis: {
         type: 'value',
         name: config.xField || 'X',
         nameLocation: 'middle',
         nameGap: 30,
         splitLine: {
            lineStyle: {
               type: 'dashed',
               color: theme === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'
            }
         }
      },
      yAxis: {
         type: 'value',
         name: config.yField || 'Y',
         splitLine: {
            lineStyle: {
               type: 'dashed',
               color: theme === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'
            }
         }
      },
      series: [
         {
            symbolSize: 15,
            data: seriesData,
            type: 'scatter',
            itemStyle: {
               color: colors[0],
               opacity: 0.8
            },
            emphasis: {
                focus: 'self',
                itemStyle: {
                    borderWidth: 2,
                    borderColor: '#fff'
                }
            }
         },
      ],
   };

   chartInstance.setOption(option);
   setupResize(container, chartInstance);

   return container;
};
